import { render, staticRenderFns } from "./ProjectSettingsModal.vue?vue&type=template&id=72d90efe&scoped=true"
import script from "./ProjectSettingsModal.vue?vue&type=script&lang=js"
export * from "./ProjectSettingsModal.vue?vue&type=script&lang=js"
import style0 from "./ProjectSettingsModal.vue?vue&type=style&index=0&id=72d90efe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d90efe",
  null
  
)

export default component.exports